import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "flex justify-center py-10"
}
const _hoisted_2 = {
  key: 1,
  "data-test": "revenue-card-error",
  class: "revenue__error"
}
const _hoisted_3 = { class: "revenue__top" }
const _hoisted_4 = {
  "data-test": "revenue-net",
  class: "revenue__net tabular-nums"
}
const _hoisted_5 = {
  "data-test": "revenue-since",
  class: "revenue__since"
}
const _hoisted_6 = ["aria-label"]
const _hoisted_7 = ["title"]
const _hoisted_8 = {
  key: 0,
  "data-test": "revenue-bar-label",
  class: "revenue__bar-label"
}
const _hoisted_9 = {
  "data-test": "revenue-split",
  class: "revenue__split"
}
const _hoisted_10 = { class: "tabular-nums" }
const _hoisted_11 = {
  "data-test": "revenue-cadence",
  class: "revenue__cadence"
}

import { computed } from 'vue'

import BasicSpinner from '@/components/BasicSpinner.vue'
import RecordButton from '@/components/customers/record/RecordButton.vue'
import RecordCard from '@/components/customers/record/RecordCard.vue'
import { averageOrder, useCustomerRevenue } from '@/composables/useCustomerRevenue'
import { customerRevenueReportPath } from '@/config/customerTabs'
import { formatDollars } from '@/helpers/money'
import {
  barsDescription,
  cadenceInterval,
  lastOrderAgo,
  lastTwelveMonths,
  monthlyBars,
  netSinceLabel,
  orderCadence
} from '@/helpers/revenueCard'
import { revenueRangeQuery } from '@/helpers/revenueRange'
import { bucketRevenueRows } from '@/services/reportParser.service'


export default {
  __name: 'CustomerRevenueCard',
  props: {
  conversationUserPairId: { type: String, required: true },
  listId: { type: String, default: null }
},
  setup(__props) {

const props = __props

const { range, months } = lastTwelveMonths()

const { rows, loading, failed, totals } = useCustomerRevenue(() => props.conversationUserPairId, range)

const bars = computed(() => monthlyBars(bucketRevenueRows(rows.value, 'month'), months))
const barsLabel = computed(() => barsDescription(bars.value))
const sinceLabel = computed(() => netSinceLabel(bars.value))
const cadence = computed(() => orderCadence(rows.value))
const split = computed(() => [
  { label: 'Gross', value: formatDollars(totals.value.gross) },
  { label: 'Refunds', value: formatDollars(totals.value.refunds) },
  { label: 'Average order', value: averageOrder(totals.value) }
])
const reportLink = computed(() => ({
  path: customerRevenueReportPath({ id: props.conversationUserPairId, listId: props.listId }),
  query: revenueRangeQuery({ preset: null, apiRange: range })
}))

return (_ctx, _cache) => {
  return (_openBlock(), _createBlock(RecordCard, {
    "data-test": "revenue-card",
    "data-tour": "customer-revenue",
    title: "Revenue",
    aside: "Last 12 months"
  }, {
    footer: _withCtx(() => [
      _createVNode(RecordButton, {
        "data-test": "revenue-report-link",
        to: reportLink.value
      }, {
        default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
          _createTextVNode("Open full report", -1)
        ]))]),
        _: 1
      }, 8, ["to"])
    ]),
    default: _withCtx(() => [
      (_unref(loading))
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createVNode(BasicSpinner, { color: "gray-900" })
          ]))
        : (_unref(failed))
          ? (_openBlock(), _createElementBlock("p", _hoisted_2, " Couldn't load revenue. Please try again. "))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, _toDisplayString(_unref(formatDollars)(_unref(totals).net)), 1),
                _createElementVNode("div", _hoisted_5, _toDisplayString(sinceLabel.value), 1)
              ]),
              _createElementVNode("div", {
                "data-test": "revenue-bars",
                class: "revenue__bars",
                role: "img",
                "aria-label": barsLabel.value
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(bars.value, (bar) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: bar.key,
                    "data-test": "revenue-bar",
                    class: _normalizeClass(["revenue__bar", [bar.gross > 0 && 'revenue__bar--sold', bar.current && 'revenue__bar--current']]),
                    style: _normalizeStyle({ height: `${bar.height}%` }),
                    title: bar.title
                  }, [
                    (bar.gross > 0)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(bar.label), 1))
                      : _createCommentVNode("", true)
                  ], 14, _hoisted_7))
                }), 128))
              ], 8, _hoisted_6),
              _createElementVNode("dl", _hoisted_9, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(split.value, (figure) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: figure.label,
                    class: "revenue__figure"
                  }, [
                    _createElementVNode("dt", null, _toDisplayString(figure.label), 1),
                    _createElementVNode("dd", _hoisted_10, _toDisplayString(figure.value), 1)
                  ]))
                }), 128))
              ]),
              _createElementVNode("p", _hoisted_11, [
                (!cadence.value)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createTextVNode("No orders in the last 12 months.")
                    ], 64))
                  : (cadence.value.everyDays === null)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _createTextVNode(" Last order was " + _toDisplayString(_unref(lastOrderAgo)(cadence.value.daysSinceLast)) + ". ", 1)
                      ], 64))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                        _cache[0] || (_cache[0] = _createTextVNode(" Orders about ", -1)),
                        _createElementVNode("b", null, _toDisplayString(_unref(cadenceInterval)(cadence.value.everyDays)), 1),
                        _createElementVNode("span", null, ". Last one was " + _toDisplayString(_unref(lastOrderAgo)(cadence.value.daysSinceLast)) + ".", 1)
                      ], 64))
              ])
            ], 64))
    ]),
    _: 1
  }))
}
}

}